import { Box, Heading } from '@chakra-ui/react';
import { componentsApi } from '@texas/api/endpoints/chat/componentsApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useEffect } from 'react';
import { ComponentLoader } from '../ComponentLoader';
import { CompositionGroupContainer } from '@texas/components/article/variant/options/shared/CompositionGroupContainer';
import { useSignalSubscriptionEvents } from '@texas/components/shared/hooks/useSignalSubscriptionEvents';
import { compositionGroupEvents } from '@texas/components/shared/compositionGroup/events';
import { compositionEvents } from '@texas/components/shared/composition/events';
import { useSetAiDimensionValueEvent } from '@texas/components/shared/compositionGroup/useSetDimensionValueEvent';

interface Props {
  componentId: number;
}

export function CompositionGroupEntity({ componentId }: Props) {
  const { refetch, loading, data, error, set } = useApiResource(
    componentsApi.getSingleCompositionGroupEntityComponent,
  );

  useEffect(() => {
    refetch(componentId);
  }, [componentId, refetch]);

  useSetAiDimensionValueEvent(set);

  useSignalSubscriptionEvents({
    triggerOnEvent: () => {
      refetch(componentId);
    },
    signalEvents: [
      compositionGroupEvents.onArchived,
      compositionGroupEvents.onRestored,
      compositionGroupEvents.onCreate,
      compositionGroupEvents.onCopy,
      compositionEvents.fileUpdated,
      compositionEvents.onRename,
      compositionGroupEvents.onRename,
      compositionEvents.onMaterialAdded,
      compositionEvents.onMaterialChanged,
      compositionEvents.onMaterialRemoved,
      compositionEvents.onAdd,
      compositionEvents.onArchived,
      compositionEvents.onRestored,
      compositionGroupEvents.onLayoutChanged,
      compositionGroupEvents.onMarkReady,
      compositionGroupEvents.onMarkNotReady,
    ],
  });

  return (
    <ComponentLoader loading={loading} error={error}>
      {data && (
        <Box>
          <Heading fontSize="md" pb={2}>
            {data.entityName}
          </Heading>
          <CompositionGroupContainer
            option={data.compositionGroup}
            isVdc={false}
            isMatrix={false}
          />
        </Box>
      )}
    </ComponentLoader>
  );
}
